











import { defineComponent, inject } from "vue";

export default defineComponent({
  setup() {
    const eventBus: any = inject("eventBus");
    function openModal() {
      eventBus.$emit("openCollabDialog", "select");
    }
    return { openModal };
  }
});
